import bus from '@/bus'

// Show an error unless the guard already did, or the user backed out
export function report(err) {
    if (!err || err.__shown__ || err.cancelled) {
        return
    }
    bus.showError(bus.firstError(err))
}

// Comes back to this page afterwards
export function signInAgain(vm) {
    const next = encodeURIComponent(vm.$route.fullPath)
    vm.$store.dispatch('LOGOUT')
    vm.$router.push({name: 'login', query: {next}})
}

function codesText(codes) {
    return codes.join('\n') + '\n'
}

export function copyCodes(codes) {
    const done = () => bus.showInfo('Copied.')
    const failed = () => bus.showError("Couldn't copy. Select the codes and copy them by hand.")
    try {
        navigator.clipboard.writeText(codesText(codes)).then(done, failed)
    } catch (e) {
        failed()
    }
}

export function downloadCodes(codes) {
    const blob = new Blob([codesText(codes)], {type: 'text/plain'})
    const url = URL.createObjectURL(blob)
    const link = document.createElement('a')
    link.href = url
    link.download = 'getmypaystub-backup-codes.txt'
    document.body.appendChild(link)
    link.click()
    link.remove()
    URL.revokeObjectURL(url)
}
